import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { InteractionStatus } from '@azure/msal-browser';
import { useMsal } from '@azure/msal-react';
import { loginRedirect } from '../services/authService';
import { useAuth } from '../context/AuthProvider';

interface Props {
  children: JSX.Element;
}

const PrivateRoute: React.FC<Props> = ({ children }) => {
  /* Forces re-evaluation on every navigation */
  useLocation();

  const { account, authenticationRequired, login } = useAuth();
  const { inProgress } = useMsal();
  const needsLogin = !account;
  const redirectStarted = useRef(false);

  useEffect(() => {
    if (needsLogin && inProgress === InteractionStatus.None && !redirectStarted.current) {
      redirectStarted.current = true;
      loginRedirect();
    }
  }, [needsLogin, inProgress]);

  if (needsLogin) {
    return null; // waiting for interactive login
  }

  if (authenticationRequired) {
    return (
      <main role="alert">
        <p>La sessione non è più valida. Accedi di nuovo per continuare.</p>
        <button type="button" onClick={login}>Accedi di nuovo</button>
      </main>
    );
  }

  return children;
};

export default PrivateRoute;
